import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import ModalError from "../Error-Span-Modal/ModalError";
import { FaArrowRight, FaIdCard, FaSignInAlt } from "react-icons/fa";

const override = {
  display: "block",
  margin: "20% auto ",
  borderColor: "white",
};

function ForgetPassword(props) {
  const { t } = useTranslation();

  const [id, setId] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [error, setError] = useState("");
  const [errorblock, setErrorBlock] = useState(false);
  const [errorClass, setErrorClass] = useState("");
  const LoginKey = process.env.REACT_APP_LOGIN_SERVICE;

  const errorHandel = (e) => {
    setErrorBlock(true);
    if (e === 0) {
      setErrorClass("errorMessage");
    } else {
      setErrorClass("successMessage");
    }
    // setTimeout(()=>{
    //   setErrorBlock(false)
    // },4000)
  };
  const errorClose = (e) => {
    setErrorBlock(e);
  };

  // forgot password change function
  const forgotPasswordHandel = (e) => {
    e.preventDefault();
    if (id === "") {
      setError("504c46e2c369d441b6eb6c581101fc85");
      errorHandel(0);
    } else {
      setIsloading(true);
      const forgotData = {
        idNumber: id,
        userCode: id,
      };

      // forgot password change service call
      axios
        .post(
          `${LoginKey}/registration/checkExistingIdCardOnRegistration`,
          forgotData
        )
        .then((response) => {
          setIsloading(false);
          if (response.data.responseObject.Data.Customer !== null) {
            props.handelValidate(true);
            props.customerData(response.data.responseObject.Data.Customer);
          } else {
            setError("213673e7c3b86758ff85fcc27459bf54");
            errorHandel(0);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsloading(false);
          setError("4b2b25d11213a09ce090cda61c0ea175");
          errorHandel(0);
        });
    }
  };



  return (
    <div className="forgot-password-wrapper">
      {errorblock && errorClass === "errorMessage" && (
          <ModalError error={t(`${error}`)} errorClose={errorClose}></ModalError>
        )}
      <div id="layoutSidenav_content" className="forgot-password-layout">
        <main>
          <header className="forgot-password-shell">
            <div className="forgot-password-container">
              <section className="forgot-password-card">
                <div className="forgot-password-card-header">
                  <div className="forgot-password-card-logo">
                    <img src="/images/new_logo.png" alt="OWCS" />
                  </div>
                  <h1 className="KhmerOSmuollighttext">
                    {t("6d909c2ed76c42670f090b269a478b7f")}
                  </h1>
                </div>

                <form className="forgot-password-form" onSubmit={forgotPasswordHandel}>
                  <div className="forgot-password-field">
                    <label className="KhmerOSsiemreaptext forgot-password-label" htmlFor="forgotLoginId">
                      {t("8e233234a83a277872b8ce305dceb914")}
                    </label>
                    <div className="forgot-password-input-wrap">
                      <FaIdCard className="forgot-password-input-icon" />
                      <input
                        className="KhmerOSsiemreaptext forgot-password-input"
                        id="forgotLoginId"
                        type="text"
                        inputMode="numeric"
                        placeholder={t("504c46e2c369d441b6eb6c581101fc85")}
                        value={id}
                        onChange={(e) => {
                          setId(e.target.value);
                        }}
                        autoComplete="username"
                      />
                    </div>
                  </div>

                  <button
                    className="KhmerOSsiemreaptext forgot-password-submit"
                    type="submit"
                  >
                    <span>{t("d0cab90d8d20d57e2f2b9be52f7dd25d")}</span>
                    <FaArrowRight />
                  </button>

                  <Link
                    className="KhmerOSsiemreaptext forgot-password-login-link"
                    to={"/login"}
                  >
                    <FaSignInAlt />
                    <span>{t("9288098bf51c8184caf86bea0722543f")}</span>
                  </Link>
                </form>
              </section>
            </div>
          </header>
        </main>
      </div>

      {isloading && (
        <div className="loderdiv">
          <ClipLoader
            color="hsla(203, 66%, 53%, 1)"
            size={80}
            cssOverride={override}
          />
        </div>
      )}
    </div>
  );
}

export default ForgetPassword;

// to_convert...
// done !
